<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="userFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col v-if="$can('manage','open-banking')" xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="user_full_name">
                                                {{ $t('label.user_full_name') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="user_full_name"
                                                    dir="rtl"
                                                    name="user_full_name"
                                                    id="user_full_name"
                                                    v-model="query.user_full_name"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="application_title">
                                                {{ $t('application.title') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="application_title"
                                                    dir="ltr"
                                                    name="application_title"
                                                    id="application_title"
                                                    v-model="query.application_title"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="application_id">
                                                {{ $t('application.app_id') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    ref="application_id"
                                                    dir="ltr"
                                                    name="application_id"
                                                    id="application_id"
                                                    v-model="query.application_id"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('open_banking.request_status') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="status"
                                                    class="form-control"
                                                    name="status"
                                                    v-model="query.status"
                                            >
                                                <option value=""></option>
                                                <option
                                                        v-bind:key="request_status"
                                                        v-for="request_status in openBankingRequestsStatus"
                                                        v-bind:value="request_status"
                                                        :selected="query.status === request_status"
                                                >
                                                    {{ openBankingRequestsStatusStr.get(request_status)}}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="$can('manage','open-banking')"  xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="provider">
                                                {{ $t('application.provider') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="provider"
                                                    class="form-control"
                                                    name="provider"
                                                    v-model="query.provider"
                                            >
                                                <option value=""></option>
                                                <option
                                                        v-bind:key="provider"
                                                        v-for="provider in providerType"
                                                        v-bind:value="provider"
                                                        :selected="query.provider === provider"
                                                >
                                                    {{ providerTypeStr.get(provider)}}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="status">
                                                {{ $t('open_banking.service') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                    size="3"
                                                    id="service_type"
                                                    class="form-control"
                                                    name="service_type"
                                                    v-model="query.service_type"
                                            >
                                                <option value=""></option>
                                              <option :value="services.BALANCE">{{ $t('application.services.' + services.BALANCE) }}</option>
                                              <option :value="services.INVOICE">{{ $t('application.services.' + services.INVOICE) }}</option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" :md="$can('manage','open-banking') ? 6 : 4">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('label.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    class=" btn btn-label-danger trash-btn"
                                                    type = "button"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                type="datetime"
                                                input-class="form-control"
                                                id="from_date"
                                                name= "from_date"
                                                v-model="query.from_date"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" :md="$can('manage','open-banking') ? 6 : 4">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('label.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    class=" btn btn-label-danger trash-btn"
                                                    type = "button"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD HH:mm:ss"
                                                display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                type="datetime"
                                                input-class="form-control"
                                                id="to_date"
                                                name= "to_date"
                                                v-model="query.to_date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="4">
                                        <kt-form-group>
                                            <kt-form-label for="source">
                                                {{ $t('open_banking.source') }}
                                            </kt-form-label>
                                            <kt-form-select
                                                size="3"
                                                id="source"
                                                class="form-control"
                                                name="source"
                                                v-model="query.source"
                                            >
                                                <option value=""></option>
                                                <option
                                                    v-bind:key="source"
                                                    v-for="source in sourceType"
                                                    v-bind:value="source"
                                                    :selected="query.source === source"
                                                >
                                                    {{ sourceTypeStr.get(source) }}
                                                </option>
                                            </kt-form-select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                <button id="open_banking_requests" type="button" class="btn btn-success btn-wide mx-4" @click="exportExcel">{{ $t('label.excel_export') }}</button>
                            </kt-form-section>
                            <kt-form-section>
                                <kt-row>
                                  <kt-col xs="12" sm="6" md="6">
                                  </kt-col>
                                </kt-row>
                              </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import {applicationServiceStatus,applicationServiceStatusStr,openBankingRequestsStatus,
    openBankingRequestsStatusStr,services,providerType,providerTypeStr} from '@/constants/openBanking'
import {userTypes,userTypesStr} from '@/constants/userTypes'
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import { KTApp } from "@/plugins/core/app";
import axios from "axios";
import {ApiUrl} from '@/common/api.service'
import {sourceType} from "@/constants/openbankingSourceType";
import {sourceTypeStr} from "../../../constants/openbankingSourceType";

export default {
    computed: {
        sourceTypeStr() {
            return sourceTypeStr
        },
        sourceType() {
            return sourceType
        }
    },
    props: {
        action: {
            default: function (e, query) {
            },
            required: true,
        }
    },
    mounted() {
        this.afterDispatch()
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        exportExcel() {
            let btn = $('#open_banking_requests');
            KTApp.progress(btn);

            const payload = {
                query: {
                    user_full_name: this.query.user_full_name,
                    application_id: this.query.application_id,
                    application_title: this.query.application_title,
                    provider: this.query.provider,
                    status: this.query.status,
                    service_type: this.query.service_type,
                    from_date: this.query.from_date,
                    to_date: this.query.to_date,
                }
            };

            let url = ''; 
            if (this.$can('manage', 'open-banking')) {
                url = `open-banking/requests/admin/export`;
            } else {
                url = `open-banking/requests/common/export`; 
            }

            axios({
                url: ApiUrl.path(url),
                method: 'POST',
                data: payload,
                responseType: 'blob',
            }).then((response) => {
                KTApp.unprogress(btn);
                const blob = new Blob([response.data]);
                const fileURL = window.URL.createObjectURL(blob);
                const fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'open-banking-requests.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
                document.body.removeChild(fileLink);
                window.URL.revokeObjectURL(fileURL);
            }).catch(({ response }) => {
                this.toastr.error(i18n.t('message.an_error_accord'));
                KTApp.unprogress(btn);
            });
        },
        clearFromDate() {
            if(this.query.from_date) {
                this.query.from_date = null
            }
        },
        clearToDate() {
            if(this.query.to_date) {
                this.query.to_date = null
            }
        },
    },
    data() {
        return {
            openBankingRequestsStatus,
            openBankingRequestsStatusStr,
            services,
            query: {
                status: null
            },
            applicationServiceStatus,
            applicationServiceStatusStr,
            userTypes,
            userTypesStr,
            providerType,
            providerTypeStr
        }
    }
}
</script>

<style>

</style>